
import { useState, useCallback } from 'react';

export const useNestedFormControl = () => {
  const [isNestedFormActive, setIsNestedFormActive] = useState(false);
  const [nestedFormType, setNestedFormType] = useState<string | null>(null);

  const startNestedForm = useCallback((formType: string) => {
    console.log(`[NestedFormControl] Starting nested form: ${formType}`);
    setIsNestedFormActive(true);
    setNestedFormType(formType);
  }, []);

  const endNestedForm = useCallback(() => {
    console.log(`[NestedFormControl] Ending nested form: ${nestedFormType}`);
    setIsNestedFormActive(false);
    setNestedFormType(null);
  }, [nestedFormType]);

  const shouldPreventSubmission = useCallback((reason?: string) => {
    const prevent = isNestedFormActive;
    if (prevent) {
      console.log(`[NestedFormControl] Preventing submission - nested form active: ${nestedFormType}`, reason ? `Reason: ${reason}` : '');
    }
    return prevent;
  }, [isNestedFormActive, nestedFormType]);

  return {
    isNestedFormActive,
    nestedFormType,
    startNestedForm,
    endNestedForm,
    shouldPreventSubmission
  };
};
